import createHttp from '@/config/http';
import type {
	InvoicePaymentLock,
	InvoicePaymentLockResponse,
} from '@/types/payment';
import type { ResponseMetaData } from '@/types/service';

// localhost:3003
// Use full URL from environment variable
const http = createHttp(import.meta.env.VITE_INVOICE_URL);

export const getInvoicePaymentsLock = async (
	page = 1,
	limit = 15,
	columnsFilters = '[]',
	search = '',
	status = 'session',
	sort = '',
): Promise<{
	items: InvoicePaymentLock[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<InvoicePaymentLockResponse>(
		'/payment-lock/db',
		{
			params: {
				type: status,
				page,
				limit,
				search,
				sort,
				columnsFilters,
			},
		},
	);
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

export const deleteInvoicePaymentLock = async (
	stripeCheckoutRef: string[],
): Promise<void> => {
	await http.delete(`/payment-lock/`, {
		data: { stripeCheckoutRef: stripeCheckoutRef },
	});
};
